var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C24.8366 32.4189 32 25.2555 32 16.4189C32 7.58239 24.8366 0.418945 16 0.418945C7.16344 0.418945 0 7.58239 0 16.4189C0 25.2555 7.16344 32.4189 16 32.4189Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.418945C9.65652 0.418945 4.17552 4.11051 1.58752 9.46245H30.4122C27.8243 4.11051 22.3432 0.418945 15.9999 0.418945V0.418945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.4192C9.65652 32.4192 4.17552 28.7276 1.58752 23.3757H30.4122C27.8243 28.7276 22.3432 32.4192 15.9999 32.4192V32.4192Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 11.5495H0.755562C0.265437 13.085 0 14.721 0 16.419C0 18.1171 0.265437 19.753 0.755562 21.2886H31.2444C31.7346 19.753 32 18.1171 32 16.419C32 14.721 31.7346 13.085 31.2444 11.5495Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9823 7.81312L19.0875 6.93855L16.0001 13.9292L12.9128 6.93855L11.0179 7.81312L14.8509 16.4193L11.0179 25.0255L12.9128 25.9001L16.0001 18.9094L19.0875 25.9001L20.9823 25.0255L17.1493 16.4193L20.9823 7.81312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.287 8.63728C16.5535 7.83622 16.0001 7.37572 16.0001 7.37572C16.0001 7.37572 15.4466 7.83615 14.7131 8.63728V24.201C15.4466 25.0022 16.0001 25.4627 16.0001 25.4627C16.0001 25.4627 16.5535 25.0023 17.287 24.2011V8.63728Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5219 11.6212V21.2157C13.297 22.5892 14.2457 23.7149 14.9567 24.4613V8.37573C14.2457 9.12204 13.2969 10.2479 12.5219 11.6212V11.6212Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4784 11.6212C18.7032 10.2478 17.7546 9.12204 17.0436 8.37573V24.4613C17.7545 23.7149 18.7032 22.5892 19.4784 21.2157V11.6212Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4781 11.6215V21.216C20.2628 19.8254 20.8695 18.1811 20.8695 16.4188C20.8695 14.6565 20.2628 13.0121 19.4781 11.6215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 11.6215V21.216C11.7371 19.8254 11.1305 18.1811 11.1305 16.4188C11.1305 14.6565 11.7371 13.0121 12.5218 11.6215Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.e143818d.svg";
export { ForwardRef as ReactComponent };